/**
 * Per-professional-type configuration for the reusable "Collaboratori" subsection.
 *
 * The collaborator UI/UX is type-driven and must stay identical to the AS-IS
 * behaviour that used to live inside each specific-data type form.
 *
 * Nota (evolutiva Codici SOL / MFA): il campo e-mail del collaboratore è stato
 * rimosso dalla subsection. L'indirizzo per l'accesso ai sistemi gestionali AXA
 * viene ora raccolto nella fase MFA dei Codici SOL (mail di accesso per
 * associazione), non più qui.
 */
export interface CollaboratorTypeConfig {
  /** When true the whole Collaboratori subsection is not shown for this type. */
  hidden: boolean;
  /** Show + require the registration-number field. */
  showRegistrationNumber: boolean;
  /** Label for the registration-number field (defaults to "Numero iscrizione albo nazionale"). */
  registrationNumberLabel?: string;
  /** Show + require "Ordine professionale". */
  showProfessionalOrder: boolean;
  /** Show public-work fields (dipendente pubblico / ente / ufficio comunicazione). */
  showPublicWork: boolean;
}

export const COLLABORATOR_TYPE_CONFIG: Record<string, CollaboratorTypeConfig> = {
  AUTO_EXPERT: { hidden: false, showRegistrationNumber: true, registrationNumberLabel: 'Numero iscrizione al Ruolo Periti Assicurativi – CONSAP', showProfessionalOrder: false, showPublicWork: false },
  RE_EXPERT: { hidden: false, showRegistrationNumber: false, showProfessionalOrder: false, showPublicWork: false },
  INVESTIGATOR: { hidden: false, showRegistrationNumber: false, showProfessionalOrder: false, showPublicWork: false },
  DOCTOR: { hidden: false, showRegistrationNumber: false, showProfessionalOrder: true, showPublicWork: true },
  LAWYER: { hidden: false, showRegistrationNumber: false, showProfessionalOrder: true, showPublicWork: false },
  BODYSHOP: { hidden: false, showRegistrationNumber: false, showProfessionalOrder: false, showPublicWork: false },
  HAIL_PROVIDER: { hidden: false, showRegistrationNumber: true, showProfessionalOrder: false, showPublicWork: false },
  NK_BODYSHOP: { hidden: true, showRegistrationNumber: false, showProfessionalOrder: false, showPublicWork: false },
  NETWORK: { hidden: true, showRegistrationNumber: false, showProfessionalOrder: false, showPublicWork: false },
};

export function getCollaboratorTypeConfig(type: string | null | undefined): CollaboratorTypeConfig {
  const key = (type || '').trim().toUpperCase();
  return (
    COLLABORATOR_TYPE_CONFIG[key] ?? {
      hidden: false,
      showRegistrationNumber: false,
      showProfessionalOrder: false,
      showPublicWork: false,
    }
  );
}
